import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import { eventCommunicator } from '../../../../../communicators/eventCommunicator'

import { AsideEventCard } from './AsideEventCard/AsideEventCard'
import EventFilter from './EventFilter/EventFilter'

import { setDateQueryParam } from '../../../../../config/functions'

import './EventList.css'

class EventList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            events: []
        }

        this.onEventIntervalSelection = this.onEventIntervalSelection.bind(this)
    }

    componentDidMount() {
        this.loadUpcomingEvents(setDateQueryParam(0, true))
    }

    async loadUpcomingEvents(startDate, endDate, categoryId) {
        categoryId = this.props.categoryId
        try {
            const eventsData = await eventCommunicator.fetchUpcomingEvents(
                1,
                startDate,
                endDate,
                categoryId
            )

            const events = eventsData.events

            this.setState({
                events
            })
        } catch (error) {
            console.error(error.message)
        }
    }

    onEventIntervalSelection = event => {
        const position = parseInt(event.target.getAttribute('data-position'), 10)
        let startDate = null
        let endDate = null
        switch (position) {
            case 0:
                startDate = setDateQueryParam(0, true)
                endDate = setDateQueryParam()
                this.loadUpcomingEvents(startDate, endDate)
                break
            case 1:
                startDate = setDateQueryParam(1)
                endDate = setDateQueryParam(7)
                this.loadUpcomingEvents(startDate, endDate)
                break
            case 2:
                startDate = setDateQueryParam(8)
                this.loadUpcomingEvents(startDate)
                break
            default:
                this.loadUpcomingEvents()
        }
    }

    render() {
        const { events } = this.state
        const { id } = this.props

        const relatedEvents = events.map((eventItem, index) => (
            <AsideEventCard event={eventItem} isActive={eventItem.id === id} key={index} />
        ))

        return (
            <Fragment>
                <aside className="event-list">
                    <div className="event-list__content">
                        <EventFilter onEventIntervalSelection={this.onEventIntervalSelection} />
                        <div className="event-list__content__all-events">{relatedEvents}</div>
                    </div>
                </aside>
            </Fragment>
        )
    }
}

EventList.propTypes = {
    categoryId: PropTypes.number.isRequired,
    id: PropTypes.number
}

export { EventList }
